import { render, staticRenderFns } from "./RecordingList.vue?vue&type=template&id=6d51e584&"
import script from "./RecordingList.vue?vue&type=script&lang=ts&"
export * from "./RecordingList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports